module.exports = __webpack_public_path__ + "img/house.2d764f9e.png";